import { create } from 'zustand'
import { LIGHT } from '../enums/themeEnums';
import { DEVELOPMENT_AND_DESIGN, JOB_OFFER } from '../enums/enums';

const useStore = create((set) => ({
  themeMode: localStorage.getItem('themeMode') || LIGHT,
  accentColor: localStorage.getItem('accentColor') || null,
  emailDialogStatus: false,
  emailDialogType: JOB_OFFER,
  serviceType: DEVELOPMENT_AND_DESIGN,
  setThemeMode: (mode) => {
    localStorage.setItem('themeMode', mode);
    set(() => ({ themeMode: mode }))
  },
  setAccentColor: (color) => {
    if (color) {
      localStorage.setItem('accentColor', color);
    } else {
      localStorage.removeItem('accentColor');
    }
    set(() => ({ accentColor: color }))
  },
  setEmailDialogStatus: (status) => {
    set(() => ({ emailDialogStatus: status }))
  },
  setEmailDialogType: (type) => {
    set(() => ({ emailDialogType: type }))
  },
  setServiceType: (type) => {
    set(() => ({ serviceType: type }))
  }
}))

export default useStore;